// Wonder cards; their effects are not implemented yet
const WonderNames =
{
    // Age A
    Colossus: "Colossus",
    HangingGardens: "Hanging Gardens",
    LibraryOfAlexandria: "Library of Alexandria",
    Pyramids: "Pyramids",
    // Age A (New Wonders and Leaders)
    Colosseum: "Colosseum",
    RomanRoads: "Roman Roads",
    Stonehenge: "Stonehenge",
    Acropolis: "Acropolis",
    // Age I
    GreatWall: "Great Wall",
    StPetersBasilica: "St. Peter's Basilica",
    TajMahal: "Taj Mahal",
    UniversitasCarolina: "Universitas Carolina",
    // Age I (New Wonders and Leaders)
    MachuPicchu: "Machu Picchu",
    HimejiCastle: "Himeji Castle",
    ForbiddenCity: "Forbidden City",
    SilkRoad: "Silk Road",
    // Age II
    EiffelTower: "Eiffel Tower",
    Kremlin: "Kremlin",
    OceanLiner: "Ocean Liner",
    TranscontinentalRailroad: "Transcontinental Railroad",
    // Age II (New Wonders and Leaders)
    HarvardCollege: "Harvard College",
    StatueOfLiberty: "Statue of Liberty",
    LouvreMuseum: "Louvre Museum",
    SuezCanal: "Suez Canal",
    // Age III
    FastFoodChains: "Fast Food Chains",
    FirstSpaceFlight: "First Space Flight",
    Hollywood: "Hollywood",
    Internet: "Internet",
    // Age III (New Wonders and Leaders)
    EmpireStateBuilding: "Empire State Building",
    UnitedNations: "United Nations",
    InternationalRedCross: "International Red Cross",
    ManhattanProject: "Manhattan Project",
}

module.exports = WonderNames;